import API from "Services/Api";
import { PersonData } from "./types";



export const updatePerson = async (person_id: number, personData: PersonData) => {
  try {
    const response = await API.put(`/persons/${person_id}`, {
      ...personData
    });

    return response.data
  } catch (err) {
    console.error(err);
    throw "Ops! Ocorreu um erro ao atualizar a pessoa";
  }
}
